<template>
  <div class="location">
    <div class="HomeConter">
      <div class="ImageTitle font12">
        ARTIST’S IMPRESSION OF TENGAH © HOUSING & DEVELOPMENT BOARD
      </div>
    </div>

    <div class="f1eee6-bg">
      <div class="m-auto w70" style="padding-top: 70px; padding-bottom: 120px;">
        <h2 class="a98b59-color lt5 Medium font30">FUTURE FORWARD</h2>
        <p class="Initial font21 Medium m-auto m-btm-50" style="width: 90%">
          From forest living in Tengah to new Jurong’s green gateway and
          sustainable future, enjoy the best of all worlds at Novo Place.
        </p>
        <div class="w100 relative mapSwiper" >
          <swiper
            class="swiperInformation"
            :options="swiperLocation"
            ref="swiperLocation"
          >
            <swiper-slide>
              <div class="img-content w100 h100">
                <img src="@/assets/gallery/JLD_Ariel View_RGB_lr.jpg" alt="" />
                <p style="right: 0">
                  ARTIST’S IMPRESSION OF JURONG LAKE DISTRICT © URA
                </p>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="img-content w100 h100">
                <img
                  src="@/assets/gallery/JID_Bulim Linear Park_RGB.jpg"
                  alt=""
                />
                <p style="right: 0">
                  ARTIST’S IMPRESSION OF BULIM LINEAR PARK © JTC
                </p>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="img-content w100 h100">
                <img
                  src="@/assets/gallery/HDB_Plantation District Lake_RGB_lr.jpg"
                  alt=""
                />
                <p class="right textEnds">
                  PLANTATION DISTRICT LAKE | PERSPECTIVE COURTESY OF THE HOUSING
                  & DEVELOPMENT BOARD. <br />
                  ILLUSTRATIONS ARE ARTISTS’ IMPRESSIONS ONLY. ACTUAL
                  DEVELOPMENTS MAY DIFFER.
                </p>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
    <div class="a98b59-bg color-white p-btm-50" style="padding-top: 90px">
      <h2 class="Initial regular lt5 p-btm-20">MINUTES FROM IT ALL</h2>
      <p class="font48 extralight Initial p-btm-50">CONVENIENCE IN EVERY DIRECTION</p>
      <div class="w70 m-auto">
        <div class="location-map-win">
          <iframe class="w100 h100" src="./maps.html" frameborder="0"></iframe>
        </div>
        <div class="w100 flex-row space-between m-top-20 map-text-group">
          <div class="w40 flex-column items-start">
            <div class="w100 flex-row m-btm-20 m-top-20">
              <img
                style="width: 35px; height: 35px; margin-right: 20px"
                src="@/assets/btn/map-logo2.png"
                alt=""
              />
              <div
                class="flex-column items-start"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial lt2">CONNECTIVITY</h4>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Tengah Park MRT Station^</span> <span>4-min walk</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Jurong East MRT Station</span>
                  <span>3 MRT stops away</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Pan Island Expressway (PIE)</span>
                  <span>2-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Kranji Expressway (KJE)</span> <span>7-min drive</span>
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 m-top-20">
              <img
                style="width: 35px; height: 35px; margin-right: 20px"
                src="@/assets/btn/map-logo5.png"
                alt=""
              />
              <div
                class="flex-column items-start"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial lt2">EDUCATION</h4>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Princess Elizabeth Primary School (&lt; 1km)</span>
                  <span>6-min walk</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Anglo-Chinese School (Primary)^ (&lt; 2km)</span>
                  <span>7-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Bukit Batok Secondary School</span>
                  <span>3-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Dulwich College (SG)</span> <span>3-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Millennia Institute</span> <span>3-min drive</span>
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 m-top-20">
              <img
                style="width: 35px; height: 35px; margin-right: 20px"
                src="@/assets/btn/map-logo4.png"
                alt=""
              />
              <div
                class="flex-column items-start"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial lt2">SHOPPING & DINING</h4>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Jem</span> <span>3 MRT stops away</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Westgate</span> <span>3 MRT stops away</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Plantation Plaza</span> <span>4-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Yuhua Village Market & Food Centre</span>
                  <span>4-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>West Mall</span> <span>6-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Tengah Town Centre^</span>
                  <span>10 to 15-min drive</span>
                </div>
              </div>
            </div>
          </div>
          <div class="map-line"></div>
          <div class="w40 flex-column items-start">
            <div class="w100 flex-row m-btm-20 m-top-20">
              <img
                style="width: 35px; height: 35px; margin-right: 20px"
                src="@/assets/btn/map-logo1.png"
                alt=""
              />
              <div
                class="flex-column items-start"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial lt2">BUSINESS</h4>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Jurong Lake District</span> <span>5-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Jurong Innovation District</span>
                  <span>10-min drive</span>
                </div>
              </div>
            </div>
            <div class="w100 flex-row m-btm-20 m-top-20">
              <img
                style="width: 35px; height: 35px; margin-right: 20px"
                src="@/assets/btn/map-logo3.png"
                alt=""
              />
              <div
                class="flex-column items-start"
                style="width: calc(100% - 45px)"
              >
                <h4 class="Initial lt2">NATURE & RECREATION</h4>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Forest Fringe^</span> <span>2-min walk</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Civil Service Club @ Bukit Batok</span>
                  <span>4-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>New Science Centre^</span> <span>5-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Little Guilin</span> <span>5-min drive</span>
                </div>
                <div
                  class="w100 flex-row space-between lh25 color-f1eee6 font14"
                >
                  <span>Jurong Lake Gardens</span> <span>6-min drive</span>
                </div>
              </div>
            </div>
            <div class="flex-column items-start" style="margin-left: 55px">
              <h4 class="Initial lt2">Legend</h4>
              <div class="flex-column items-start color-f1eee6 font12">
                <p class="textStarts Initial lh25">
                  <span
                    ><img
                      style="width: 50px; margin-right: 10px"
                      src="@/assets/location/mapBtm1.png"
                      alt="" /></span
                  ><span>Jurong Region Line (U/C)</span> <br />
                  <span
                    ><img
                      style="width: 50px; margin-right: 10px"
                      src="@/assets/location/mapBtm2.png"
                      alt="" /></span
                  ><span>East-West Line</span> <br />
                  <span
                    ><img
                      style="width: 50px; margin-right: 10px"
                      src="@/assets/location/mapBtm3.png"
                      alt="" /></span
                  ><span>North-South Line</span> <br />
                  <span
                    ><img
                      style="width: 50px; margin-right: 10px"
                      src="@/assets/location/mapBtm4.png"
                      alt="" /></span
                  ><span>Downtown Line</span> <br />
                  <span
                    ><img
                      style="width: 50px; margin-right: 10px"
                      src="@/assets/location/mapBtm5.png"
                      alt="" /></span
                  ><span>Park Connector Network (PCN)</span>
                </p>
                <p class="textStarts">
                  ^ Future amenities <br />
                  * Station names to be confirmed <br /><br />
                  Actual travel time may vary due to traffic conditions. <br />
                  <br />
                  All information is correct at time of printing and <br />
                  is subject to change without prior notice.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-525c4e a98b59-color relative w100" style="padding-top: 70px;padding-bottom: 50px;">
      <h2 class="Initial lt5 regular m-btm-20 m-top-20">REVITALISED JURONG</h2>
      <p class="font48 Initial m-btm-20 p-btm-20 extralight">
        NEW WAYS TO WORK, REST AND PLAY
      </p>
      <div class="w100">
        <img class="w60 m-auto" src="@/assets/location/map1.png" alt="" />
      </div>

      <img
        class="w100 p-btm-20"
        style="margin-top: -25px;"
        src="@/assets/btn/line3.png"
        alt=""
      />

      <div class="IntroduceConter flex-row-reverse w60">
        <div class="textStart" style="width: 32%">
          <h2 class="a98b59-color info-title">JURONG LAKE DISTRICT</h2>
          <p class="info-text">
            As Singapore’s largest mixed-use business district outside of the
            city centre, this district is set to grow. With its 120 hectares of
            new space for businesses to scale, Jurong Lake District is slated to
            create over 100,000 new jobs
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/location/JLD_Business Bldgs_RGB_lr.png" alt="" />
          <p class="right">ARTIST’S IMPRESSION OF JURONG LAKE DISTRICT © URA</p>
          
        </div>
      </div>
      <div class="IntroduceConter flex-row-reverse w60">
        <div class="textStart" style="width: 32%">
          <h2 class="a98b59-color info-title">NATURE AT YOUR DOORSTEP</h2>
          <p class="info-text">
            Jurong Lake District is your little Eden with 90 hectares of parks
            and open spaces. There are 17km of waterfront trails for walking and
            cycling and restored wetlands at Jurong Lake Gardens for
            birdwatching.
          </p>
        </div>
        <div class="img-content">
          <img
            src="@/assets/location/JLD_Waterfront Promenade_RGB.jpg"
            alt=""
          />
          <p class="right">
            ARTIST’S IMPRESSION OF WATERFRONT PROMENADE ALONG JURONG LAKE © URA
          </p>
          
        </div>
      </div>
      <div class="IntroduceConter w60">
        <div class="textEnd" style="width: 32%">
          <h2 class="a98b59-color info-title">LEISURE ON A NEW LEVEL</h2>
          <p class="info-text">
            With retail favourites like Westgate, Jem and IMM, you’re spoilt for
            choice. You can also expect next-level entertainment such as
            exciting learning adventures at the new Science Centre.
          </p>
        </div>
        <div class="img-content">
          <img
            src="@/assets/location/New Science Ctr_Stargazing_RGB_hr.png"
            alt=""
          />
          <p class="left">
            ARTIST’S IMPRESSION OF THE NEW SCIENCE CENTRE © SCIENCE CENTRE
            SINGAPORE
          </p>
        </div>
      </div>
      <div class="IntroduceConter flex-row-reverse w60">
        <div class="textStart" style="width: 32%">
          <h2 class="a98b59-color info-title">
            JURONG INNOVATION <br />
            DISTRICT
          </h2>
          <p class="info-text">
            Set to transform Singapore’s advanced manufacturing landscape, it is
            green and bright, with 95,000 new jobs at your doorstep.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/location/JID_v4-Final-JTC_RGB_hr.jpg" alt="" />
          <p class="right">
            ARTIST’S IMPRESSION OF JURONG INNOVATION DISTRICT © JTC
          </p>
        </div>
      </div>
    </div>
    <div class="bg-575252 a98b59-color relative w100" style="padding-top: 90px;padding-bottom: 50px;">
      <h2 class="Initial lt5 regular m-btm-20 m-top-20">NEW TENGAH</h2>
      <p class="font48 Initial m-btm-50 extralight">THE SMART AND SUSTAINABLE TOWN</p>

      <div class="IntroduceConter p-top-50 w60">
        <div class="textEnd" style="width: 32%">
          <h2 class="a98b59-color info-title">WELL-CONNECTED</h2>
          <p class="info-text">
            Green and smart, Tengah is also very much about unsurpassed
            connectivity. You’re a four-minute walk to the upcoming Tengah Park
            MRT station on the future Jurong Region Line. And a mere three MRT
            stops to Jurong East. With ample walking and cycling paths through
            Tengah and a park connector nearby, getting around couldn't be
            easier or greener.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/location/Novo_MRT Lady_RGB_hr.png" alt="" />
          <p class="left">FOR ILLUSTRATION ONLY</p>
        </div>
      </div>
      <div class="IntroduceConter flex-row-reverse w60">
        <div class="textStart" style="width: 32%">
          <h2 class="a98b59-color info-title">NATURE’S NURTURE</h2>
          <p class="info-text">
            Novo Place is located at Plantation District, home to community
            farming at Plantation Farmway. And with a beautiful Forest Fringe
            running alongside Novo Place, the forest is literally at your
            doorstep. It also connects you to the Forest Corridor, linking you
            to an even larger green network.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/location/Novo_Family Nature_RGB_lr.jpg" alt="" />
          <p class="left">FOR ILLUSTRATION ONLY</p>
        </div>
      </div>
      <div class="IntroduceConter flex-row-reverse w60">
        <div class="textStart" style="width: 32%">
          <h2 class="a98b59-color info-title">NEAR GOOD SCHOOLS</h2>
          <p class="info-text">
            You’re close to good schools covering all stages of education. Not
            only is Princess Elizabeth Primary School within 1km and the future
            Anglo-Chinese School (Primary) within 2km, Nanyang Technological
            University (NTU) is nearby, too.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/location/PEPS_AndyL_RGB_lr.jpg" alt="" />
          <p class="left">PRINCESS ELIZABETH PRIMARY SCHOOL</p>
        </div>
      </div>
      <div class="IntroduceConter w60">
        <div class="textEnd" style="width: 32%">
          <h2 class="a98b59-color info-title">
            EVERYTHING YOU <br />
            NEED CLOSE BY
          </h2>
          <p class="info-text">
            Enjoy the convenience of Tengah’s first neighbourhood centre,
            Plantation Plaza, minutes from you. Or head to the future Tengah
            Town Centre for more shopping and dining options. Also, just a short
            bus or MRT ride away are Bukit Batok West Shopping Centre, Yuhua Village Market & Food Centre, and West Mall.
          </p>
        </div>
        <div class="img-content">
          <img src="@/assets/location/Novo_Grocery Shop_RGB_hr.png" alt="" />
          <p class="right">FOR ILLUSTRATION ONLY</p>
          
        </div>
      </div>
    </div>
    <contant />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";

export default {
  components: {
    Footer,
    contant,
  },
  data() {
    return {
      swiperLocation: {
        pagination: {
          el: ".swiper-pagination", //与分页器的类名绑定
          // type: 'progressbar', //选择分页器的类型（默认为小圆点）
          clickable: true, // 点击分页器跳切换到相应的幻灯片(不是所有分页器都支持)
        },
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less">
.location {
  width: 100%;
  // height: calc(100vh + 56px);
  margin-top: -56px;
  .map-line {
    width: 1px;
    background-color: #f1eee6;
    height: 445px;
    margin: auto;
  }
  .location-map-win{
    width: 100%;
    height: 60vw;
  }
  .HomeConter {
    height: calc(100vh - 110px);
    background-image: url("~@/assets/location/HDB_Town Center_RGB_lr.jpg");
    background-size: cover;
    background-position-y: 75%;
    position: relative;
  }
  .IntroduceConter {
    padding-bottom: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    .img-content {
      height: 20vw !important;
      width: 40vw !important;
    }
  }
  .swiperInformation {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.551);
    // border-radius: 10px;
    .swiper-slide {
      width: 100%;
      height: 100%;
      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }
    }
    .swiper-pagination-bullet-active {
      background-color: white !important;
    }
    .swiper-pagination-bullet {
      border: 2px solid white;
      border-radius: 2px;
      background-color: #00000000;
    }
  }
  .mapSwiper{
      height: 40vw;
    }
}
@media (max-width: 900px) {
  .location {
    .HomeConter {
      height: 30vh;
      background-position-y: 0;
    }
    .w70 {
      width: 100%;
    }
    .location-map-win{
      margin: auto;
      width: 90%;
      height: 400px;
    }
    .mapSwiper{
      height: 40vh;
    }
    .map-text-group {
      flex-direction: column !important;
      .w40 {
        width: 90%;
        margin: auto;
      }
      .map-line {
        display: none;
      }
    }
    .IntroduceConter .img-content {
      height: 40vw !important;
      width: 80vw !important;
    }
  }
  .swiper-container{
    padding-bottom: 35px;
    background-color: #00000000 !important;
  }

  .swiper-pagination-bullet {
    width: 5px;
    height: 5px;
  }
  .IntroduceConter {
    width: 100% !important;
    flex-direction: column-reverse !important;
  }
  .textEnd,
  .textStart {
    width: 85% !important;
    text-align: center !important;
    margin: auto;
  }
  .IntroduceConter h2 {
    font-size: 15px;
    margin-top: 20px;
    margin-bottom: 0;
  }
  .IntroduceConter p {
    width: auto !important;
    line-height: 20px !important;
    margin: 3px;
    font-size: 11px;
    letter-spacing: 0;
  }
}
</style>












